import React, { useState, useCallback } from 'react';

import * as Yup from 'yup';
import { isEmpty } from 'lodash';

import { t } from '~/helpers';
import { Report } from '~/components';
import { Autocomplete, RadioGroup } from '~/components/Form';

export default function EstoquePosto() {
  const [open, setOpen] = useState(true);
  const [post, setPost] = useState({});
  const [organ, setOrgan] = useState({});

  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const handleValidate = useCallback(async (data) => {
    try {
      const schema = Yup.object().shape({
        orgao: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(data, { abortEarly: false });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }, []);

  const onSerializeData = useCallback((data) => ({
    ...data,
    postostr: post.poco_descricao,
    orgaostr: organ.orga_nome,
  }), [post, organ]);

  return (
    <Report
      open={open}
      onClose={handleCloseReport}
      serialize={onSerializeData}
      validate={handleValidate}
      title="Estoque"
      relatorio="estoqueposto"
      initials={{ tipo: 'pdf' }}
    >
      <Autocomplete
        name="orgao"
        label="orga_nome"
        title="Órgão"
        url="orgaos"
        unique="orga_codigo"
        getValue={(value) => setOrgan(value)}
      />

      <Autocomplete
        name="posto"
        label="poco_desc_abrev"
        title="Posto"
        url="postosporusuario"
        unique="poco_codigo"
        getValue={(value) => setPost(value)}
        disabled={isEmpty(organ)}
        params={{
          wherefield: ['orga_codigo'],
          valuewherefield: [organ.orga_codigo],
          typewherefield: ['EQUALS'],
        }}
      />

      <RadioGroup
        row
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
      />
    </Report>
  )
}
